import { render, staticRenderFns } from "./Industrys.vue?vue&type=template&id=983e9524&"
import script from "./Industrys.vue?vue&type=script&lang=js&"
export * from "./Industrys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports